import { makeRequest } from "../../baseApi";
import { makeResourceUrl } from "../../../utils/url/url";
import { parseAudio } from "./utils";
import { makeAudioDownloadCancelTokenKey } from "../books/constants";

export const fetchAudioFileAsBase64 = (
  chapterId, src, onDownloadProgress, onCancel
) => {
  return makeRequest({
    url: makeResourceUrl(src),
    responseType: "arraybuffer",
    parseResponse: parseAudio,
    onDownloadProgress,
    onCancel,
    cancelTokenKey: makeAudioDownloadCancelTokenKey(chapterId),
  });
};
